import type { MutableRefObject, ReactNode } from 'react'
import type SvgIcon from '../SvgIcon/SvgIcon'
import type { Directions } from '../utilities/directions'
import type {
  ClickRowActionEventHandler,
  GroupedTableColumns,
  Limit,
  TableRow,
} from './TableContext'

export type Actions =
  | {
      type: ActionTypes.ChangeLimit
      limit: Limit
    }
  | {
      checked: boolean
      key: string
      type: ActionTypes.FilterChange
      value: string
    }
  | { type: ActionTypes.FirstPage }
  | {
      type: ActionTypes.MoveColumn
      direction: Directions.Left | Directions.Right
      key: string
    }
  | { type: ActionTypes.NextPage }
  | { type: ActionTypes.PreviousPage }
  | {
      type: ActionTypes.SortColumn
      direction: Directions.Ascending | Directions.Descending
      key: string
    }
  | { type: ActionTypes.ToggleColumn; key: string }
  | {
      type: ActionTypes.ToggleRow
      key: string
      selectionsRef?: MutableRefObject<string[]>
    }
  | {
      type: ActionTypes.ToggleRows
      status: string
      selectionsRef?: MutableRefObject<string[]>
    }
  | {
      type: ActionTypes.UpdateLoading
      loading: boolean
    }
  | {
      type: ActionTypes.UpdateRows
      rows: TableRow[]
      selectionsRef?: MutableRefObject<string[]>
      total?: number
    }
  | {
      type: ActionTypes.UpdateRowActions
      rowActions?: {
        enabled?: (row: TableRow) => boolean
        label: ReactNode
        handler: ClickRowActionEventHandler
        startAdornment?: typeof SvgIcon
      }[]
    }
  | {
      type: ActionTypes.UpdateColumns
      columns: GroupedTableColumns
    }
  | {
      type: ActionTypes.UpdateScrolling
      isScrolling: boolean
    }
  | {
      type: ActionTypes.UpdateScrollable
      scrollable: boolean
    }
  | {
      type: ActionTypes.UpdateDense
      dense: boolean
    }
  | {
      type: ActionTypes.UpdateSelectable
      selectable: boolean
    }
  | {
      type: ActionTypes.SyncSelections
      ids: string[]
    }

export enum ActionTypes {
  MoveColumn,
  SortColumn,
  ToggleColumn,
  UpdateColumns,

  FilterChange,

  ToggleRow,
  ToggleRows,
  UpdateRows,

  UpdateRowActions,

  ChangeLimit,

  FirstPage,
  NextPage,
  PreviousPage,

  UpdateLoading,

  UpdateScrolling,
  UpdateScrollable,
  UpdateDense,
  UpdateSelectable,
  SyncSelections,
}
